module.exports = __webpack_public_path__ + "assets/img/banner@2x.0c54aed4.png";